//TopBar.js
import React, { PureComponent } from "react";
import "normalize.css"; // normalize.css
import Snackbar from "components/Snackbar";
import { StyleSheet, css } from "aphrodite/no-important";
import TopBar from "components/TopBar";
import Dashboard from "components/Dashboard";
import ClientSite from "components/ClientSite";
import Login from "components/Login";
import "typeface-roboto";
import { PropagateLoader } from "react-spinners";
import Server from "components/Server";
import FullPageLoader from "components/FullPageLoader";
import SetupSlide from "components/SetupSlide";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Tour from "reactour";
import GridItem from "components/GridItem";
import Cache from "Cache";
import Common from "components/Common";
import SideBar from "components/SideBar";
import Moon from "packages/Moon";

const styles = {
	main: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		backgroundColor: "rgba(250, 250, 250, 1)",
		position: "relative",
		top: 0
	},
	appLayout: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap"
	},
	topbar: {
		width: "100%",
		height: "64px",
		maxWidth: "100%",
		backgroundColor: "white",
		boxShadow: "0px 0px 15px rgba(0,0,0,0.2)",
		position: "relative",
		zIndex: 5
	},
	contentLayout: {
		width: "100%",
		height: "calc(100% - 64px)",
		maxWidth: "100%",
		display: "flex",
		flexDirection: "row",
        flexWrap: "nowrap",
        overflow: "auto",
	},
	SideBar: {
		width: "250px",
		minWidth: "250px",
		height: "100%",
		maxWidth: "100%",
		backgroundColor: "rgba(245,245,245,1)",
		boxShadow: "inset -5px 0px 15px rgba(0,0,0,0.2)",
		zIndex: 4,
		flexWrap: "nowrap",
		overflow: "hidden"
	},
	context: {
		flex: 1,
		height: "100%"
	},
	loading: {
		padding: "0px",
		margin: "0px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%"
	},
	closeTourButton: {
		borderRadius: "3px",
		backgroundColor: "white",
		textTransform: "uppercase",
		padding: "10px 25px",
		border: "none",
		cursor: "pointer",
		color: "#333"
	},
	fullWidthHeight: {
		width: "100%",
		height: "100%"
	}
};

const className = StyleSheet.create({
	tourBox: { minWidth: "350px", maxWidth: "90%" }
});

class App extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			login: false,
			dashboard: true,
			openClientSite: false,
			showSetupSlide: false,
			isTourOpen: false,
			tourType: "app",
			tourDisableInteraction: true,
			tourAccentColor: "#3f51b5",
			version: ""
		};
		window.App = this;
		this.closeSetupSlide = this.closeSetupSlide.bind(this);
		this.closeTour = this.closeTour.bind(this);
		this.openTour = this.openTour.bind(this);
	}

	componentDidMount() {
		this.login();
	}

	openAppTour() {
		let appTour = Cache.getCookie("appTour");
		if (appTour == null || appTour != "true") this.state.isTourOpen = true;
	}

	reopenTour(showInfo) {
		if (showInfo == null) showInfo = true;
		Cache.eraseCookie("appTour");
		Cache.eraseCookie("sortingTour");
		if (showInfo == true)
			Snackbar.info(
				"Tour enabled - you will see it on your next visit :-)"
			);
	}

	loading() {
		return (
			this.state.loading && (
				<div style={styles.loading}>
					<PropagateLoader
						color={"#123abc"}
						loading={true}
						size={15}
					/>
				</div>
			)
		);
	}

	closeSetupSlide() {
		this.setState({ showSetupSlide: false });
	}

	login() {
		let demo = Common.isDemo();
		Server.post("/login", { demo: demo }, this.loginDone.bind(this), null, this.onForbidden.bind(this));
	}

    onForbidden() {
        this.setState({
            loading: false,
            login: false,
            showSetupSlide: false,
        });
    }

	loginDone(res) {
		let auth = res.data.auth;
		if (auth === true) {
            let hostApi = res.data.hostApi;
            let platform = res.data.platform;
			if (hostApi != null && hostApi.length > 0) {
				let demo = Common.isDemo();
				if (demo) this.reopenTour(false);
				this.openAppTour();
				this.getVersion();
			} else
				this.setState({
					loading: false,
					login: true,
                    showSetupSlide: true,
                    platform: platform
				});
		}
	}

	getVersion() {
		Server.post("/webpage/get_version", {}, this.getVersionDone.bind(this));
	}

	getVersionDone(res) {
		this.setState({ loading: false, login: true, version: res.data.version });
	}

	toggleDashboard(toggle) {
		this.setState({ dashboard: toggle });
	}

	openCategory(categoryId, categoryUrl, categoryType, categoryName) {
		this.setState(
			{
				openClientSite: false
			},
			() =>
				setTimeout(() => {
					this.setState({
						dashboard: false,
						openClientSite: true,
						categoryId: categoryId,
						categoryUrl: categoryUrl,
						categoryType: categoryType,
						categoryName: categoryName
					});
				}, 10)
		);
	}

	renderContent() {
		if (this.state.login == false || this.state.showSetupSlide == true)
			return null;
		return (
			<div style={styles.contentLayout}>
				<SideBar
					open={true}
					openCategory={this.openCategory.bind(this)}
					style={styles.SideBar}
				/>
				<Dashboard open={this.state.dashboard} style={styles.context} />
				{this.renderClientSite()}
			</div>
		);
	}

	renderClientSite() {
		if (this.state.openClientSite == false) return null;
		return (
			<ClientSite
				open={!this.state.dashboard}
				style={styles.context}
				categoryId={this.state.categoryId}
				categoryUrl={this.state.categoryUrl}
				categoryType={this.state.categoryType}
				categoryName={this.state.categoryName}
				openTour={this.openTour}
			/>
		);
	}

	renderSetupSlide() {
		if (this.state.showSetupSlide == false) return null;
		return (
			<div style={styles.contentLayout}>
				<SetupSlide closeSetupSlide={this.closeSetupSlide} platform={this.state.platform} />
			</div>
		);
    }
    
    renderLogin() {
		if (this.state.login != false || this.state.showSetupSlide != false) return null;
		return (
			<div style={styles.contentLayout}>
				<Login />
			</div>
		);
	}

	closeTour() {
		let cookieDays = 1825;
		if (Common.isDemo()) cookieDays = 0.05;
		Cache.setCookie(this.state.tourType + "Tour", true, cookieDays);
		this.setState({ isTourOpen: false });

		if (this.state.tourType == "sorting") ClientSite.onResize();
	}

	openTour(tourType = "app") {
		this.setState({ isTourOpen: true, tourType: tourType });
	}

	render() {
		return (
			<div style={styles.main}>
				<CssBaseline />

				{this.loading()}
				<Snackbar oKey={"snackbar"} />
				<FullPageLoader />
				{(
					<div style={styles.appLayout}>
						<TopBar
							style={styles.topbar}
							showButtons={!this.state.showSetupSlide && this.state.login }
						/>
						{this.renderSetupSlide()}
                        {this.renderLogin()}
						{this.renderContent()}
						<Tour
							accentColor={this.state.tourAccentColor}
							className={css(className.tourBox)}
							steps={
								this.state.tourType == "app"
									? appSteps
									: sortingSteps
							}
							isOpen={this.state.isTourOpen}
							startAt={0}
							disableInteraction={
								this.state.tourDisableInteraction
							}
							disableDotsNavigation={true}
							onRequestClose={this.closeTour}
						/>
					</div>
				)}
			</div>
		);
	}
}

const appSteps = [
	{
		selector: ".first-step",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Welcome to SortVisually :-)
				</Typography>
				<br />
				Let's do a quick tour
			</div>
		)
	},
	{
		selector: "#categories",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Categories SideBar
				</Typography>
				<br />
				Here you can select category and start sorting your items
			</div>
		)
	},
	{
		selector: "#userButton",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					User stuff
				</Typography>
				<br />
				Click here for settings or logout
			</div>
		)
	},
	{
		selector: "#helpme",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Help me!
				</Typography>
				<br />
				Click here if you have any questions (coming soon)
			</div>
		)
	}
];

const sortingSteps = [
	{
		selector: "#item0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item view
				</Typography>
				<br />
				Here you can see all item details
				<br />
				you can drag & drop on other items for sorting
			</div>
		),
		action: node => {
			GridItem.items[0].showQuantityDetails(false);
		}
	},
	{
		selector: "#selectableItem0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Selectable item
				</Typography>
				<br />
				You can select multiple items by clicking here or by holding{" "}
				<strong style={{ color: "red" }}>Ctrl</strong> key and clicking
				on item
			</div>
		)
	},
	{
		selector: "#itemSort0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item sort position
				</Typography>
				<br />
				See current item sort position, any sorting will change this
				value
			</div>
		),
		action: node => {
			GridItem.items[0].showQuantityDetails(false);
		}
	},
	{
		selector: "#quantityDetails0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item stock
				</Typography>
				<br />
				Easly review item stock by hover here
			</div>
		),
		action: node => {
			GridItem.items[0].showAdditionalAttributes(false);
			GridItem.items[0].showQuantityDetails(true);
		}
	},
	{
		selector: "#additionalAttributes0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item additional attributes
				</Typography>
				<br />
				Hover here to see more item details
			</div>
		),
		action: node => {
			GridItem.items[0].showQuantityDetails(false);
			GridItem.items[0].showAdditionalAttributes(true);
		}
	},
	{
		selector: "#openURL0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item source
				</Typography>
				<br />
				Click here if you want to see this item on your system (new tab)
			</div>
		),
		action: node => {
			GridItem.items[0].showAdditionalAttributes(false);
		}
	},
	{
		selector: "#itemPrice0",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Item price
				</Typography>
				<br />
				Nothing special :-)
			</div>
		),
		action: node => {
			GridItem.items[0].showAdditionalAttributes(false);
		}
	},
	{
		selector: "#searchBox",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px" }}>
				<Typography variant="h5" color={"secondary"} gutterBottom>
					Search
				</Typography>
				<br />
				You can search items from this category
			</div>
		),
		action: node => {
			window.App.setState({
				tourAccentColor: "#3f51b5"
			});
		}
	},
	{
		selector: "",
		content: ({ goTo, inDOM }) => (
			<div style={{ width: "350px", color: "white" }}>
				<p style={{ color: "#fff", fontSize: "30px" }}>Play time!</p>
				<p style={{ color: "#ddd" }}>
					Its time to play, drag items on each other and see the
					magic!
				</p>
				<p style={{ color: "#eee", fontSize: "22px" }}>
					<strong>One day you will call us magicians</strong>
				</p>
				<button
					style={styles.closeTourButton}
					onClick={() => {
						window.App.closeTour();
					}}
				>
					Close Tour
				</button>
			</div>
		),
		action: node => {
			window.App.setState({
				tourAccentColor: "#f50057"
			});
		},
		style: {
			backgroundColor: "#3f51b5"
		}
	}
];

export default App;
